import {AfterViewInit, Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {Translatable} from "../../../../../Translatable";
import {DataTableDirective} from "angular-datatables";
import {Subject} from "rxjs";
import {BsDatepickerConfig, BsModalRef, BsModalService} from "ngx-bootstrap";
import {document, partenaire, transaction,transactionFail} from "../../../../model/db";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthServiceService} from "../../../../service/auth-service.service";
import {HttpClient} from "@angular/common/http";
import {ToastrService} from "ngx-toastr";
import {HelperService} from "../../../../service/helper.service";
import {NgxUiLoaderService} from "ngx-ui-loader";
import {DataTablesResponse} from "../../../../model/DataTablesResponse";
import {environment} from "../../../../../../environments/environment";
import * as $ from "jquery";
import {valuesys} from "../../../../../../options";
import Swal from "sweetalert2";


@Component({
  selector: 'app-troubleshoot',
  templateUrl: './troubleshoot.component.html',
  styleUrls: ['./troubleshoot.component.css']
})
export class TroubleshootComponent extends Translatable implements  OnInit, AfterViewInit,OnDestroy {

  //DATATABLE
  /*REFRESH*/

  /**
   * datatble variable
   */

  
   searchInput : any= "";
   filtreSelect : any= 10;
   where : any= "";
   tabExportEtud : any= "";
   searchCustom : any= "";
   endPOint : any= "";
   child : any= "";
   tri : any= "";
   order : any= "";
  
     //--paginate
     public paginateListe : any = [];
     public nextPage : any = [];
     public prevPage : any = [];
     public lastPage : any = [];
     public firstPage : any = [];
     public currentPage : any = [];
     public total : any = [];
     public path : any = [];
     public lastNumPage : any = [];
     public infoData : any = [];
     public cPage_less_2 : number;
     public path_cPage_less_2 : any;
     public cPage_less_1 : number;
     public path_cPage_less_1 : any;
     public cPage_more_1 : number;
     public path_cPage_more_1 : any;
     public cPage_more_2 : number;  
     public path_cPage_more_2 : any;
     public searchColumn: string;
     public columnTemp;
     public childTemp;
 
    //--end-paginate
   
 
 
  /**
   * 
      end datatable variable
   */
  
  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  // @ts-ignore
  dtTrigger: Subject = new Subject();
  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }
  public dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();

//Date filter
  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  private endTime = " 23:59:59" ;
  date_debut : Date = new Date();
  date_debut_query : string = '';
  date_fin : Date = new Date();
  date_fin_query : string="";
  idPartenaire : number = 0;

  formatQuery(){
    this.date_debut_query = this.dateFormating(this.date_debut);
    this.date_fin_query = this.dateFormating(this.date_fin);
  }

  dateFormating(date) : string
  {
    let year = date.getFullYear();
    let month = date.getMonth()+1;
    let dt = date.getDate();

    if (dt < 10) {
      dt = '0' + dt;
    }
    if (month < 10) {
      month = '0' + month;
    }
    return year+'-' + month + '-'+dt;
  }

  //Date filter
  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }
  /*REFRESH*/

  title:string ;
  dtOptions: DataTables.Settings = {};
  modalRef: BsModalRef;
  titleModal:string ;
  isAdd : boolean = true ;
  isValid : boolean = false ;
  public transactions :transaction[] = [] ;
  public transactionFails : transactionFail[] = [];
  public transactionFailsSelectedKey : number[] = [];
  public partenaires : partenaire[] = [];
  public transaction:transaction = new transaction();
  public transaction_details: transaction;
  public transaction_error : transaction ;
  statut: string = '';
  private lang_ = Translatable.getLang();
  statut_list: any[] = [
    {id:0, text:'NON VALIDÉ'},{id: 1, text:'VALIDÉ'}
  ];


  constructor(private activatedRoute: ActivatedRoute,
              private auth : AuthServiceService,
              private http: HttpClient,
              private httpClient: HttpClient,
              private toastr: ToastrService,
              private helper: HelperService,
              private modalService: BsModalService,
              private ngxService: NgxUiLoaderService,
              private route: Router
  ) {
    super();
  }

  async ngOnInit() {
    this.title = this.__("transaction.transactions");
    this.auth.initAutority("SUP");
    this.initDatatable();
    
    this.date_debut = new Date();
    this.date_fin = this.date_debut;
    console.log("tesstt");
    this.getListPartenaire();
    this.formatQuery()
    this.child= `child=client,partenaire,service,abonnement,userValid`;
    this.endPOint = environment.troubleshoot+"?page=1";
    //this.getUrlDatatable(this.endPOint)
    //this.getDataTroubleShoot();
  }

  async getDataTroubleShoot()
  {
    if( this.idPartenaire != 0 )
    {
      this.transactionFailsSelectedKey = [];
      this.formatQuery();
      let response: any = await this.httpClient.post<any>(
        environment.troubleshootList, 
        {"date_debut":this.date_debut_query, "date_fin":this.date_fin_query, "partenaire_id" : this.idPartenaire}, 
        valuesys.httpAuthOptionsProcess()
      ).toPromise();
      
      if(response["code"] == 200 && !response["error"]){
          this.transactionFails = response["data"]["transactions"];
          this.rerender();
      }
    }else{
      Swal.fire({
        title: this.__("swal.requiredPartenaire"),
        icon: 'warning',
        showCancelButton: false
      });
    }
    
  }

  async selectTransaction(evt,keyTransaction)
  {
      let isChecked:boolean = evt.target.checked;

      if(isChecked)
      {
        this.transactionFailsSelectedKey.push(keyTransaction);
      }else{
        const index = this.transactionFailsSelectedKey.indexOf(keyTransaction);
        this.transactionFailsSelectedKey.splice(index, 1);
      }
  }

  async validateTransaction()
  {
    if( this.idPartenaire != 0 )
    {
      var transactionConfirmValidate=[];
      
      this.transactionFailsSelectedKey.forEach((keyValue) => {
          transactionConfirmValidate.push(this.transactionFails[keyValue].object);
      })

      if(transactionConfirmValidate.length != 0)
      {
        
        Swal.fire({
          title: 'Validé les transactions ?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Oui',
          cancelButtonText : "Annuler"
        }).then(async (result)  => {

            if(result['value'] != undefined && result['value'])
            {
              this.formatQuery();
              let response: any = await this.httpClient.post<any>(
                environment.troubleshoot, 
                {"transactions":transactionConfirmValidate}, 
                valuesys.httpAuthOptionsProcess()
              ).toPromise();
            
              
              if(response["code"] == 200 && !response["error"]){
                  Swal.fire('Enregistré !', '', 'success');
                  this.transactionFails = response["data"]["transactions"];
                  for(let i = 0; i < this.transactionFails.length; i++){
                    this.transactionFails[i].status_partenaire = "Validée";
                  };
                  this.rerender();
              }else{
      
                  Swal.fire({
                    title: "Une erreur interne est survenue .",
                    icon: 'warning',
                    showCancelButton: false
                  });
      
              }
            }
        })
        
       
        
      }else{

        Swal.fire({
          title: "Veuillez séléctionner au moins une transaction.",
          icon: 'warning',
          showCancelButton: false
        });

      }
      
    }else{
      Swal.fire({
        title: this.__("swal.requiredPartenaire"),
        icon: 'warning',
        showCancelButton: false
      });
    }
  }


  async getListPartenaire()
  {
    let response : any = await this.httpClient.get(
        environment.partenaire,
        valuesys.httpAuthOptionsProcess()
    ).toPromise();
    
    this.partenaires = response["data"];
    console.log(this.partenaires);
  }

  initDatatable() {
    console.log('assets/i18n/'+this.lang_+'/datatable_fr.json');
    this.isAdd = true;
    this.isValid = false;
    this.dtOptions = {
      lengthMenu: [[10, 20, 50,100,200,300,500, -1], ["10", "20", "50","100","200","300","500", "Tout"]],
      processing: true,
      language : {
        url: 'assets/i18n/'+this.lang_+'/datatable_fr.json'
      }
    };
  }

  close(){
    this.modalRef.hide()
    this.isValid = false ;
    this.transaction = new transaction()
    this.transaction_error = new transaction();


  }
  

  checkValideTransaction()
  {
    Swal.fire({
      title: this.__("swal.confirmCheckTransaction"),
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText : "Annuler",
    }).then((result) => {
      
      if (result) {
        this.validateTransaction();
      } else {
        Swal.fire('Changes are not saved', '', 'info')
      }

    });
  }

  async toggleState(transaction:transaction,statut:number,btn:any,type='statut'){

    btn.disabled = true;

    // ACTIVATION
    if(statut == 1)
    {
      Swal.fire({
        title: this.__("swal.confirmTitle"),
        text: this.__("swal.confirmValidateTransaction"),
        icon: 'warning',
        input: 'text',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: this.__('swal.no'),
        confirmButtonText: this.__('swal.yes'),
        preConfirm: (inputValue) => {
          
          if(inputValue == "")
          {
            Swal.showValidationMessage(this.__("swal.requiredConfirmPartenaire"));
          }
          
        }
      }).then(
        async (result) => {
          
          if(!result.dismiss)
          {
            let toogle = await this.http.post<any>(environment.regularise ,{ transaction_id: transaction.id, statut: statut ,transaction_partenaire : result.value}, valuesys.httpAuthOptions()).toPromise();
              if (toogle.data.Erreur == "False") {
                this.toastr.success(toogle.data.Message, this.__("msg.success"));
                transaction[type] = toogle.data[type]
                this.rerender();
  
              } else {
                this.toastr.error(toogle.data.Message, this.__("msg.error"));
                btn.disabled = false;
              }
          }else{
            btn.disabled = false;
          }
           
      });
    }

    // REJET
    if(statut == 2)
    {
      Swal.fire({
        title: this.__('swal.confirmTitle'),
        text: this.__('swal.confirmMsg'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: this.__('swal.no'),
        confirmButtonText: this.__('swal.yes')
      }).then(async (result) => {
        
        if(!result.dismiss)
        {
          if (result.value) {
            let toogle = await this.http.post<any>(environment.regularise ,{ transaction_id: transaction.id, statut: statut }, valuesys.httpAuthOptions()).toPromise();
            if (toogle.data.Erreur == "False") {
              this.toastr.success(toogle.data.Message, this.__("msg.success"));
              transaction[type] = toogle.data[type]
              this.rerender();
    
            } else {
              this.toastr.error(toogle.data.Message, this.__("msg.error"));
              btn.disabled = false;
            }
          
          }
        }else{
          btn.disabled = false;
        }
        
      });
    }
  }

  
  print(transactions:transaction[]){
   
    
    return  transactions.map((transaction)=>{
      let t = {}
     
      t[this.__('print.date')] = transaction.date_transaction
      t[this.__('print.num_transact')] = transaction.num_transaction
      t[this.__('print.service')] = transaction.service.name
      t[this.__('print.montant')] = window['accounting'].formatNumber( transaction.montant, 2, "  ");
      t[this.__('print.numero_installation')] = (transaction.abonnement !== null) ? transaction.abonnement.num_compteur  : "";
      t[this.__('facture.num_facture')] = transaction.num_facture ;
      t[this.__('facture.num_ticket')] = transaction.num_ticket;
      /* t[this.__('print.prenom')] = transaction.client.prenom
      t[this.__('print.nom')] = transaction.client.nom*/
      t[this.__('print.partenaire')] = transaction.partenaire.name
      t[this.__('print.statut')] =  (transaction.statut == 0 ? this.__("tooltip.running") : (transaction.statut == 1) ? this.__('tooltip.validate') : this.__('tooltip.rejeter'))
      return t ;
    })  || [];

  }


  /**
   * datatable function
   */


   async getUrlDatatable(url,col = "",refElement?: any,child?:string){



    // let query = ""
    // if (this.status != "8"){
    //   query = `,statut|e|${this.status}`
    // }
    console.log("avant",this.date_debut);
    console.log("avant fin",this.date_fin);
    this.formatQuery();
    console.log("apres",this.date_debut_query);
    console.log("apres fin",this.date_fin_query);
    let query = ""
    if (this.statut){
      query = `,statut|e|${this.statut}`
    }
    if(this.date_debut_query != ''){
    this.child =`child=client,partenaire,service,abonnement,transaction,userValid&where=date_transaction|se|${this.date_debut_query },date_transaction|ie|${this.date_fin_query  + this.endTime},${query}`;
  }

    if(refElement ){
     this.searchColumn = refElement.value
     this.columnTemp = col;
     this.childTemp = child;
    }
 
    let name = [
      'search_ref',
      'num_client_ref',
      'prenom_ref',
      'nom_ref',
      'mail_ref',
      'telephone_ref',
      'typeclient_ref',
    ]
     
     if(col != "" || this.searchColumn){
       if(this.searchColumn !="" && this.searchColumn !="undefined"){
         this.searchCustom = "&child_where="+this.childTemp+"|"+this.columnTemp+"|l|"+this.searchColumn+"";
       }else if(this.searchColumn == ""){
        this.searchCustom = "";
       }
     }else{
       if(this.searchInput !="" && this.searchInput !="undefined"){
         this.searchCustom = "&child_where_or=transaction|date_transaction|l|"+this.searchInput+",transaction|num_transaction|l|"+this.searchInput+",transaction|num_facture|l|"+this.searchInput+",transaction|montant|l|"+this.searchInput+",transaction|num_ticket|l|"+this.searchInput+",service|name|l|"+this.searchInput+",partenaire|name|l|"+this.searchInput+"";
       }else if(this.searchInput == ""){
        this.searchCustom = "";
       }
     }
     
 
     let filtre : any= "";
     if(this.filtreSelect !="" && this.filtreSelect !="undefined"){
       filtre = "&per_page=" + this.filtreSelect;
       console.log("filter",this.filtreSelect)
     }
     let triage : any= "";
     if(this.tri !="" && this.tri !="undefined"){
       triage = "&__order__="+ this.order+","+ this.tri;
     }

 
     let toogle = await this.http.post<any>(url +"&"+ this.child + this.searchCustom  + filtre + triage  ,valuesys.httpAuthOptions()).toPromise();
     this.transactions = toogle.data.data;
     console.log("url",this.transactions)
 
    
 
     
     this.firstPage = toogle.data.first_page_url;
     this.prevPage = toogle.data.prev_page_url ;
     this.nextPage = toogle.data.next_page_url ;
     this.lastPage = toogle.data.last_page_url ;
     this.lastNumPage = toogle.data.last_page;
     this.path = toogle.data.path;
     this.currentPage = toogle.data.current_page;
     this.total = toogle.data.total;
 
     
 
     this.cPage_less_2 = 0
     this.cPage_less_1 = 0
     if(this.currentPage > 1 ){
       
       if(this.currentPage > 2 ){
         this.cPage_less_2 = this.currentPage - 2
         this.path_cPage_less_2 = this.path +"?page="+this.cPage_less_2;
       }
     
     this.cPage_less_1 = this.currentPage - 1 
     this.path_cPage_less_1 = this.path +"?page="+this.cPage_less_1;
     }
 
     
     this.cPage_more_1 = 0
     this.cPage_more_2 = 0
     if(this.currentPage < this.lastNumPage){
       this.cPage_more_1 = this.currentPage + 1 
       this.path_cPage_more_1 = this.path +"?page="+this.cPage_more_1;
 
       if(this.currentPage < this.lastNumPage - 1 ){
         this.cPage_more_2 = this.currentPage + 2 
         this.path_cPage_more_2 = this.path +"?page="+this.cPage_more_2;
       }
 
     }
 
     let info = this.__('datatable.info').replace('_START_', toogle.data.from)
     let info2 =info.replace('_END_', toogle.data.to)
     this.infoData = info2.replace('_TOTAL_', toogle.data.total)
 
   }

   async triTable(col, order){
     this.tri = col;
     this.order = order;
     this.getUrlDatatable(environment.troubleshoot+"?page=1")
   }


  

   /**
    * end datatable funciton
    */

}
